import { render, staticRenderFns } from "./DeliveryStatisticsFilter.vue?vue&type=template&id=04c6eb7a&scoped=true"
import script from "./DeliveryStatisticsFilter.vue?vue&type=script&lang=js"
export * from "./DeliveryStatisticsFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c6eb7a",
  null
  
)

export default component.exports